export type ServiceStatusValue = "REQUESTED" | "CANCELED" | "COMPLETED";

export enum ServiceStatus {
  REQUESTED = "신청중",
  CANCELED = "신청 취소",
  COMPLETED = "처리 완료",
}
